import React from 'react';

import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { connectRefinementList } from 'react-instantsearch-dom';

import { DEFAULT_URL } from '../../const';
import { CategoryNavigation } from '../CategoryNavigation';

const ExpertNavigationBlock = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <CategoryNavigation
        link={`${DEFAULT_URL}/experts`}
        title={t('page.discover.backToExperts')}
      />
    </Box>
  );
};

export default connectRefinementList(ExpertNavigationBlock);
